module.exports = __webpack_public_path__ + "static/media/train_51.9f47824f.jpg";